module.exports = __webpack_public_path__ + "static/media/trading.74142ef5.svg";